(() => {
  'use strict';
  const lazyImages = 'img[data-foneso-lazy-src]';

  function restore(slideEl) {
    if (!(slideEl instanceof Element)) return;
    slideEl.querySelectorAll(lazyImages).forEach((img) => {
      const src = img.dataset.fonesoLazySrc;
      if (!src) return; // already restored: all navigation signals are safe to repeat
      const srcset = img.dataset.fonesoLazySrcset;
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      img.removeAttribute('data-foneso-lazy-placeholder');
      img.removeAttribute('data-foneso-placeholder');
      delete img.dataset.fonesoLazySrc;
      delete img.dataset.fonesoLazySrcset;
    });
  }

  function init() {
    // The marker is rendered only by template.suffix == speedtest.
    const gallery = document.querySelector('[data-foneso-view="speedtest"]');
    if (!gallery) return;
    const track = gallery.querySelector('slideshow-slides[ref="scroller"]');
    if (!track) return;
    const slideshow = track.closest('slideshow-component');
    const slides = () => Array.from(track.querySelectorAll(':scope > slideshow-slide'));

    function targetFromScroll() {
      const all = slides();
      if (!all.length) return null;
      return all.reduce((nearest, slide) =>
        Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(nearest.offsetLeft - track.scrollLeft) ? slide : nearest,
      all[0]);
    }

    function restoreTargetAndNeighbors(target) {
      const all = slides();
      const index = all.indexOf(target);
      if (index < 0) return;
      restore(all[index - 1]);
      restore(all[index]);
      restore(all[index + 1]);
    }

    let scrollTimer;
    function restoreFromScroll() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => restoreTargetAndNeighbors(targetFromScroll()), 80);
    }

    let observing = false;
    function activateTrackObserver() {
      if (observing || !('IntersectionObserver' in window)) return;
      observing = true;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) restoreTargetAndNeighbors(entry.target);
        });
      }, { root: track, threshold: 0.6 });
      slides().forEach((slide) => observer.observe(slide));
    }

    // Horizon dispatches this on its slideshow component for select, arrows, drag and track scroll.
    slideshow?.addEventListener('slideshow:select', (event) => {
      activateTrackObserver();
      const selected = event.detail?.slide || event.slide;
      restoreTargetAndNeighbors(selected instanceof Element ? selected : targetFromScroll());
    });

    // Native horizontal scroll covers direct scrolling and wheel navigation.
    track.addEventListener('scroll', () => { activateTrackObserver(); restoreFromScroll(); }, { passive: true });
    // Touch/pointer completion covers swipe including the theme drag controller.
    ['touchend', 'touchcancel', 'pointerup', 'pointercancel', 'pointercapturelost'].forEach((type) =>
      track.addEventListener(type, () => { activateTrackObserver(); restoreFromScroll(); }, { passive: true })
    );
    // Explicit thumbnail, dots and previous/next fallback; actual slide is resolved after Horizon moves the track.
    slideshow?.addEventListener('click', (event) => {
      const control = event.target instanceof Element && event.target.closest(
        '.slideshow-controls__thumbnail, .slideshow-controls__dots button, [on*="/select/"], slideshow-arrows .slideshow-control, .slideshow-controls__arrows .slideshow-control'
      );
      if (!control) return;
      activateTrackObserver();
      setTimeout(restoreFromScroll, 0);
      setTimeout(restoreFromScroll, 180);
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
